export default "Hello,\n\nI would like to request CORE Dashboard Premium for {{ organisationName }} (ID {{ organisationId }}).\n\nSincerely,\n{{ userName }}\n";